import React from 'react';
import { useNavigate } from "react-router-dom";
import "./LocationPage.css";
import LocationListHeader from './components/LocationListHeader';
import ManagedDeviceList from 'components/ManagedDeviceList';
import { useAuth } from "context/AuthContext";
import { ITEM_NUM_PER_PAGE_LOCATION } from 'constants/config';

const propTypes = {};
const defaultProps = {};
const LocationPage = (props) => {
  /*** States and Variables ***/
  const [keyword, setKeyword] = React.useState('');
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  /*** Event Handlers ***/
  const onSearch = (originalKeyword, keywords) => {
    setKeyword(originalKeyword);
  }

  const handleViewTypeChange = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue === "交通量一覧") {
      navigate("/traffic");
    }
  };

  /*** Main Render ***/
  return <div className='location_page_container'>
    <LocationListHeader
      keyword={keyword}
      onSearch={onSearch}
    />

    {/* <div className="location-selectors-container" style={{ padding: '0.5rem 1rem' }}>
      <select className="location-view-type-selector" value="設置箇所一覧" onChange={handleViewTypeChange}>
        <option value="交通量一覧">交通量一覧</option>
        <option value="設置箇所一覧">設置箇所一覧</option>
      </select>
    </div> */}

    <ManagedDeviceList keyword={keyword} type="LOCATION" currentUser={currentUser} itemNumPerPage={ITEM_NUM_PER_PAGE_LOCATION} />
  </div>;
}
LocationPage.propTypes = propTypes;
LocationPage.defaultProps = defaultProps;
export default LocationPage;
